module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAWlBMVEVHcEzLy8vNzc3MzMzQ0NDMzMzMzMy/v7/MzMzNzc3MzMzNzc3Pz8/R0dHMzMzNzc3MzMzMzMzLy8vMzMzMzMzLy8vNzc3Ly8vKysrU1NTOzs7Nzc3R0dHMzMyJg7ihAAAAHXRSTlMASWvkG/3yDMK3m/hPHPvB829P+Zxs5PwdDG7CC8yfAH8AAADCSURBVDjLzZNJFoMgEAVRVECNQ5yT1P2vmYUKDrzH1r9hUZ+mJ4R4ll6xkUUhTfzy4iSv2FTlyZ2XGQdl7ytvU05KP5f7Fw7pKUaScVN2zCMHaCK9Ih01APmhvgogEkoDaCUigMpVG7MBpe0BxNZg1tC1Ekp/LcdYg8Q5FsuR1lDsmdc/4TjF3aCVEIvHIB1XyveEcbzWviRdmbW/zGCjgq0OD8s37jKwMG1g5UrP0vbTjqc+8e71PJix60YzzA/7j394/CfZ+P4LyQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app/cleartext@2x.png
// module id = 235
// module chunks = 4